module.exports = __webpack_public_path__ + "static/media/Mobile_Governe_sua_empresa_através_dos_padrões_e_boas_práticas_de_ITIL_e_COBIT.c1903cfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Governe_sua_empresa/Mobile_Governe_sua_empresa_através_dos_padrões_e_boas_práticas_de_ITIL_e_COBIT.png
// module id = 108
// module chunks = 0